import { render, staticRenderFns } from "./ROI.vue?vue&type=template&id=61f3d51a&scoped=true&"
import script from "./ROI.vue?vue&type=script&lang=js&"
export * from "./ROI.vue?vue&type=script&lang=js&"
import style0 from "./ROI.vue?vue&type=style&index=0&id=61f3d51a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f3d51a",
  null
  
)

export default component.exports